import "./App.css";
import { useState } from "react";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const togglePrivacyPolicy = () => {
    setShowPrivacyPolicy(!showPrivacyPolicy);
  };

  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Zoocoinz - A platform for trading and investing in animal-themed cryptocurrencies" 
          className="hero-image" 
        />
        <p className="eyebrow">Zoocoinz · Empowering Your Investment Journey</p>
        <h1>Invest in Animal-Themed Cryptocurrencies</h1>
        <p className="lede">
          Discover unique opportunities in the world of crypto that celebrate your love for animals.
        </p>
        <div className="cta-row">
          <button onClick={togglePrivacyPolicy} className="secondary">
            Privacy Policy
          </button>
        </div>
      </header>

      {showPrivacyPolicy && (
        <section className="privacy-policy">
          <h2>Privacy Policy</h2>
          <p>
            At Zoocoinz, we are committed to protecting your privacy. This Privacy Policy outlines
            the types of information we collect, how we use it, and your rights regarding your data.
          </p>
          <p>
            We collect data through analytics tools and cookies to enhance your experience on our
            platform. Cookies are small files stored on your device that help us understand how
            you interact with our site.
          </p>
          <p>
            Third-party vendors, including Google AdSense, may use cookies to serve ads based on
            your prior visits to our site or other sites on the internet. You can manage your
            preferences regarding these cookies by visiting 
            <a href="https://myaccount.google.com/data-and-privacy" target="_blank"> Google's ad settings</a>.
          </p>
          <p>
            If you have any questions about our privacy practices, please contact us at 
            <a href="mailto:privacy@zoocoinz.com"> privacy@zoocoinz.com</a>.
          </p>
        </section>
      )}

      <section className="cards">
        <article>
          <h2>Market Insights</h2>
          <p>
            Stay updated with the latest market analysis of animal-themed cryptocurrencies to make informed decisions.
          </p>
        </article>
        <article>
          <h2>Investment Strategies</h2>
          <p>
            Learn effective investment strategies tailored for beginners in the crypto space.
          </p>
        </article>
        <article>
          <h2>Community Stories</h2>
          <p>
            Explore inspiring stories and projects from our vibrant community of animal lovers and crypto enthusiasts.
          </p>
        </article>
        <article>
          <h2>Regulatory Updates</h2>
          <p>
            Keep abreast of important regulatory updates that impact the cryptocurrency landscape.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;